export default __webpack_public_path__ + "static/media/010_home.hevc.27e60503.mp4";